import { Platform } from 'helpers/platform';
import {
    type NotificationType,
    addNotificationHandler,
} from 'store/middleware/displayNotification';
import { type GlobalState } from 'store/reducer';
import {
    studentModuleEncoding,
    studentModuleSelector,
    studentNextModuleSelector,
} from '@lingoda/modules';
import { studentMovedToNextModuleSelector, studentNotificationsSelector } from '@lingoda/students';

let notificationShown: GenericObject<unknown> = {};

export const check = (state: GlobalState): NotificationType | undefined => {
    const module = studentModuleSelector(state);
    if (!module) {
        return;
    }

    const studentNotifications = studentNotificationsSelector(state);
    const encoding = studentModuleEncoding(state, undefined);
    const nextModule = studentNextModuleSelector(state, undefined);
    const movedToNextModule = studentMovedToNextModuleSelector(state);
    const movedToNextModuleScenario = module.cefrLevelName && module.completed && nextModule;

    if (
        (movedToNextModuleScenario && movedToNextModule && !notificationShown[encoding]) ||
        (!movedToNextModuleScenario &&
            studentNotifications &&
            !studentNotifications[encoding] &&
            !notificationShown[encoding] &&
            ((module.cefrLevelName && module.completedPercentage >= 90) ||
                (!module.cefrLevelName && module.completed) ||
                (!module.cefrLevelName && module.completedPercentage >= 90 && nextModule)))
    ) {
        notificationShown = { ...notificationShown, ...{ [encoding]: true } };

        return { type: 'moduleFinishing' };
    }
};

void addNotificationHandler({
    check,
    clean: () => (notificationShown = {}),
    dependencies: ['modules'],
    platforms: [Platform.SBE],
});
